<ins-context-menu #contextMenu [blockMenu]="blockMode | async"></ins-context-menu>
<div class="contentContainer">
  @if (sceneMode === SceneMode.Load) {
    <div class="visible loadingOrChooseContainer">
      @if (accessibleSitesCount == 0) {
        <div class="loadingOrChooseWrapper">
          You don't have access to any sites.
        </div>
      }
      @if (!noSiteSelected && accessibleSitesCount == -1) {
        <div class="loadingOrChooseWrapper">
          Please wait while the application is loading...
        </div>
      }
      @if (noSiteSelected) {
        <div class="loadingOrChooseWrapper">
          <mat-icon class="ChooseSiteIcon" svgIcon="sidebar.sites"></mat-icon>
          <div style="margin-left: 16px; white-space: pre-line;">
            {{loadSiteContext}}
          </div>
        </div>
      }
    </div>
  }
  @if (appConf.showMap) {
    <ins-maps-container [class.visible]="sceneMode === SceneMode.Map" [activeSiteInfo]="activeSite$ | async" [openedPanel]="openedPanel"
    [sites]="sites$ | async" (openContextMenu)="contextMenu.displayMenuByCoord($event, true)"></ins-maps-container>
  }
  <ins-webgl-container [class.visible]="sceneMode === SceneMode.Facility" [activeSite]="activeSite$ | async" [openedPanel]="openedPanel"
  (openContextMenu)="contextMenu.displayMenuByCoord($event)"></ins-webgl-container>
  <ins-pano-container [sceneMode]="sceneMode" [openedPanelName]="openedPanel" [panoSceneBlocked]="blockMode | async"
  [class.visible]="sceneMode === SceneMode.Panoramic" [rightMenuOpened]="rightMenuOpen$ | async"></ins-pano-container>
</div>

<!--Right side action controllers-->
@if (appConf.webGLToolbar) {
  <ins-controllers-panel class="actionButtons" [blockMenu]="blockMode | async" [class.hidden]="sceneMode === SceneMode.Panoramic"  [sceneMode]="sceneMode"
  [activeSiteInfo]="activeSite$ | async" [menuOpen]="rightMenuOpen$ | async" [appConf]="appConf"></ins-controllers-panel>
}

